import video from './modules/snippets/video.js';
import onload from './modules/snippets/onload.js';
import Navigation from './modules/snippets/Navigation.js';
import Field from './modules/snippets/Field.js';
import Timeline from './modules/snippets/Timeline.js';
import events from './modules/snippets/events.js';
import Lightbox from './modules/snippets/lightbox.js';
import player from './modules/snippets/player.js';

/**
 * Snippets
 */
new onload();
new Navigation();
new Field();
new Timeline();

let index_current = '';

const isSafari =
  /constructor/i.test(window.HTMLElement) ||
  (function(p) {
    return p.toString() === '[object SafariRemoteNotification]';
  })(
    !window['safari'] ||
      (typeof safari !== 'undefined' && safari.pushNotification)
  );
const introLine = document.getElementsByClassName('field-title')[0]
  .childNodes[10];
const introFieldTitle = document.getElementsByClassName('field-title')[0];
const aboutLogos = document.getElementsByClassName('logos-wrapper')[0];

// isSafari ? introLine.classList.add('intro-safari') : null;
isSafari ? introFieldTitle.classList.add('intro-safari--title') : null;
isSafari ? aboutLogos.classList.add('about-safari--logos') : null;

// const linkEasyChair = document.getElementsByClassName('module-section__text--large');
// linkEasyChair[0].childNodes[0].childNodes[1].setAttribute('class', 'link--xl');
// linkEasyChair[1].childNodes[1].childNodes[1].setAttribute('class', 'link--xl');

document.toggleTalk = element => {
  element.classList.toggle('active');
};

document.toggleIframesWrapper = (wrapper_id, day) => {
  index_current = wrapper_id;
  if (day == 1) {
    const className = `#video-wrapper-${wrapper_id}_dayOne`;
    const domNode = document.querySelector(className);
    const wrapper_iframe = document.querySelector('.wrapper_iframes');
    domNode.classList.add('active');
    wrapper_iframe.classList.add('active');
  } else if (day == 2) {
    const className = `#video-wrapper-${wrapper_id}_dayTwo`;
    const domNode = document.querySelector(className);
    const wrapper_iframe = document.querySelector('.wrapper_iframes');
    domNode.classList.add('active');
    wrapper_iframe.classList.add('active');
  }
};

document.hideIframes = (wrapper_id, day) => {
  const className = day == 1 ? `#video-wrapper-${wrapper_id}_dayOne` : `#video-wrapper-${wrapper_id}_dayTwo`;
  const domNode = document.querySelector(className);
  const wrapper_iframe = document.querySelector('.wrapper_iframes');
  domNode.classList.remove('active');
  wrapper_iframe.classList.remove('active');
  const iframeElement = domNode.getElementsByTagName('iframe')[0];
  const iframeSrc = iframeElement.src;
  iframeElement.src = iframeSrc;
};

document.onkeydown = function(evt) {
  evt = evt || window.event;
  if (evt.keyCode == 27) {
    const className = `#video-wrapper-${index_current}`;
    const domNode = document.querySelector(className);
    const wrapper_iframe = document.querySelector('.wrapper_iframes');
    domNode.classList.remove('active');
    wrapper_iframe.classList.remove('active');
    const iframeElement = domNode.getElementsByTagName('iframe')[0];
    const iframeSrc = iframeElement.src;
    iframeElement.src = iframeSrc;
  }
};

const documentationTrigger = document.getElementsByClassName(
  'photo-documentation'
);
[...documentationTrigger].forEach(triggerElement => {
  new Lightbox(triggerElement);
});



// WEBPACK FOOTER //
// ./src/index.js